export default __webpack_public_path__ + "static/media/2023-03-02T06_09_28.848Z_2_4.78739da6.jpeg";